var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('whiteboard-fabric',{ref:"whiteboard",on:{"mouse:down:before":_vm.test}}),_c('whiteboard-menu',{attrs:{"items":[_vm.modes, _vm.actions]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }